"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODULE_MENU = void 0;
var MODULE_MENU;
(function (MODULE_MENU) {
    MODULE_MENU[MODULE_MENU["FEED"] = 1] = "FEED";
    MODULE_MENU[MODULE_MENU["CURSOS"] = 2] = "CURSOS";
    MODULE_MENU[MODULE_MENU["TESORERIA"] = 3] = "TESORERIA";
    MODULE_MENU[MODULE_MENU["TRAMITES"] = 4] = "TRAMITES";
    MODULE_MENU[MODULE_MENU["SIMULACION"] = 5] = "SIMULACION";
    MODULE_MENU[MODULE_MENU["ACCESO_CAMPUS"] = 6] = "ACCESO_CAMPUS";
    MODULE_MENU[MODULE_MENU["SOLICITUDES"] = 7] = "SOLICITUDES";
    MODULE_MENU[MODULE_MENU["GESTION_SERVICIOS"] = 8] = "GESTION_SERVICIOS";
    MODULE_MENU[MODULE_MENU["USUARIOS_PERMISOS"] = 9] = "USUARIOS_PERMISOS";
    MODULE_MENU[MODULE_MENU["USUARIOS"] = 10] = "USUARIOS";
    MODULE_MENU[MODULE_MENU["ROLES"] = 11] = "ROLES";
    MODULE_MENU[MODULE_MENU["PERMISOS"] = 12] = "PERMISOS";
    MODULE_MENU[MODULE_MENU["EDUCACION_CONTINUA"] = 13] = "EDUCACION_CONTINUA";
    MODULE_MENU[MODULE_MENU["SYSTEM"] = 14] = "SYSTEM";
    MODULE_MENU[MODULE_MENU["TOPOGRAFIA"] = 15] = "TOPOGRAFIA";
    MODULE_MENU[MODULE_MENU["PALETA"] = 16] = "PALETA";
    MODULE_MENU[MODULE_MENU["NOTIFICACIONES"] = 17] = "NOTIFICACIONES";
    MODULE_MENU[MODULE_MENU["CURSOS_ADMINISTRADOS"] = 18] = "CURSOS_ADMINISTRADOS";
    MODULE_MENU[MODULE_MENU["ESTATUS_ORDENES"] = 19] = "ESTATUS_ORDENES";
    MODULE_MENU[MODULE_MENU["COUPONS_MANAGEMENT"] = 21] = "COUPONS_MANAGEMENT";
    MODULE_MENU[MODULE_MENU["ASESORIAS"] = 22] = "ASESORIAS";
    MODULE_MENU[MODULE_MENU["DEGREE"] = 29] = "DEGREE";
    MODULE_MENU[MODULE_MENU["ADMIN_DEGREE"] = 30] = "ADMIN_DEGREE";
    MODULE_MENU[MODULE_MENU["RECEPCION_DOCUMENTOS"] = 31] = "RECEPCION_DOCUMENTOS";
    MODULE_MENU[MODULE_MENU["MANAGE_MEMBERSHIP"] = 32] = "MANAGE_MEMBERSHIP";
})(MODULE_MENU = exports.MODULE_MENU || (exports.MODULE_MENU = {}));
